import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import MainLayout from './layout/MainLayout';
import TermsOfService from './pages/legal/TermsOfService';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import Careers from './pages/Careers';
import Games from './pages/Games';
import ColorPalette from './pages/ColorPalette';
import NightWanders from './pages/projects/NightWanders';
import ConfusedFeelings from './pages/projects/ConfusedFeelings';
import Kensley from './pages/projects/Kensley';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route element={<MainLayout />}>
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/games" element={<Games />} />
          <Route path="/colors" element={<ColorPalette />} />
          <Route path="/projects/night-wanders" element={<NightWanders />} />
          <Route path="/projects/confused-feelings" element={<ConfusedFeelings />} />
          <Route path="/projects/kensley" element={<Kensley />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
